import { Component, ViewChild } from '@angular/core';
import { ControllerForViewBase } from '../../../framework/controller-for-view-base';
import { NgForm } from '@angular/forms';
import { SaveUserCommandRequest, GetUserCommandRequest, GetUserCommandResponse, UserDto } from '../../../../data/CommandServiceDtos.generated';
import { ActivatedRoute, Params } from '@angular/router';
import { PageContainerService } from '../../../../services';
import { CanComponentDeactivate } from '../../../../services/can-deactivate-guard.service';
import { forEach } from 'lodash';

@Component({
  standalone: false,
  selector: 'user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent extends ControllerForViewBase implements CanComponentDeactivate {
  @ViewChild('form') form: NgForm;
  model: UserDto = new UserDto();
  getActionText = () => 'Modify';

  constructor(private activatedRoute: ActivatedRoute, public pcs: PageContainerService) {
    super(pcs);
    this.pcs.actionLinksPanelService.addBackButton();
    this.pcs.actionLinksPanelService.addActionLinks([{
      text: 'Save ',
      fontAwesomeIcon: 'save',
      onClick: () => { this.submit() }
    }]);
    this.pcs.actionLinksPanelService.addActionLinks([{
      text: 'Save and Close',
      fontAwesomeIcon: 'save',
      onClick: () => { this.submit(true) }
    }]);
  }

  async load(id: number) {
    let getCommandRequest: GetUserCommandRequest = new GetUserCommandRequest();
    getCommandRequest.Id = id;
    let getCommandResponse = await this.pcs.apiService.GetUser(getCommandRequest);
    this.mapResponseToModel(getCommandResponse);
  }

  async ngOnInit() {
    let userId: number;
    this.activatedRoute.params.subscribe((params: Params) => {
      userId = +params['id'];
      this.load(userId);
    });
  }

  mapResponseToModel(getCommandResponse: GetUserCommandResponse): void {
    this.model = getCommandResponse.UserDto;
  }

  async submit(navigateaway: boolean = false): Promise<void> {
    let saveRequest: SaveUserCommandRequest = {
      UserDto: this.model
    }
    let saveResponse = await this.pcs.apiService.SaveUser(saveRequest, undefined, true);
    if (saveResponse.Id !== 0) {
      this.form.form.markAsPristine();
      this.updateUrlForNewEntity(['/user', saveResponse.Id]);
      if (navigateaway) {
        window.history.back();
      } else {
        this.load(saveResponse.Id);
      }
    }
  }

  canDeactivate(): Promise<boolean> {
    var promise = Promise.resolve(true);
    if (this.form.dirty)
      return this.pcs.showUnsavedChangesDialog();
    return promise;
  }
}
